import { render, staticRenderFns } from "./FinancialSummary.vue?vue&type=template&id=b06bda32&scoped=true"
import script from "./FinancialSummary.vue?vue&type=script&lang=js"
export * from "./FinancialSummary.vue?vue&type=script&lang=js"
import style0 from "./FinancialSummary.vue?vue&type=style&index=0&id=b06bda32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06bda32",
  null
  
)

export default component.exports